
import Vue from 'vue'
import { getStorageUrl } from '@/services/firebase-storage'

export default Vue.extend({
  name: 'RVideo',
  props: {
    clip: {
      type: String,
      default: 'clips/walkthrough',
    },
  },
  data() {
    return {
      videoWasPaused: false,
    }
  },
  methods: {
    getClipPath(format: string): string {
      return getStorageUrl(`clips/${this.clip}.${format}`)
    },
    handlePause(): void {
      if (!this.videoWasPaused) this.videoWasPaused = true
      this.$emit('pause')
    },
    handlePlay(): void {
      if (this.videoWasPaused) {
        this.$emit('resume')
      } else {
        this.$emit('play')
      }
    },
  },
})
